import baseSetBackgroundImage from './assets/background/background.webp';

export const background = {
  background: `
    linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%),
    linear-gradient(0deg, #5776FF 0%, #5776FF 100%),
    url("${baseSetBackgroundImage}") center / cover repeat
  `,
  backgroundBlendMode: 'normal, hue, normal',
};
